'use client';
import { trackUser } from '@api/tracking/client';
import { useOnce } from '@mentimeter/react-hooks';

interface TrackProps extends Record<string, string> {
  event: string;
}

const Track: React.FC<TrackProps> = (props) => {
  const { event, ...properties } = props;
  useOnce(true, () => {
    trackUser({ event, properties });
  });
  return null;
};

export default Track;
